const Index = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
  routes: [
    {
      path: '/proj/rept/index',
      name: 'proj_rept_index',
      component: Index
    }
  ]
}
